import { makeStyles, Paper, Theme, createStyles } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import Header from '../../../components/Header/Header';
import TrendsContainer from '../../../components/Devices/Trends/TrendsContainer';

// Constants
import { APP_TITLE } from '../../../utils/constants';
import { GetString } from '../../../components/StringResourceManager';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../store';
import {
  getAssetStoreList,
  getDivisionList,
  getLaneNumbers,
  getNodeGroups,
  getNodeTypeList,
} from '../../../store/Assets/AssetsActions';
import { useEffect } from 'react';
import { getCurrentIssueCategories } from '../../../store/Devices/AssetStatesActions';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperGrid: {
      marginTop: theme.spacing(7),
      display: 'flex',
      flexDirection: 'column',
    },
  }),
);

export default function TrendsSubMenu() {
  const classes = useStyles();

  const isLogin: boolean = useSelector(
    (state: ApplicationState) => state.userSessionReducer.isLoggedIn,
  );
  const dispatch: Dispatch<any> = useDispatch();

  useEffect(() => {
    if (isLogin) {
      getAssetStoreList(dispatch);
      getDivisionList(dispatch);
      getLaneNumbers(dispatch);
      getNodeTypeList(dispatch);
      getNodeGroups(dispatch);
      getCurrentIssueCategories(dispatch);
    }
    return () => {};
  }, [isLogin]);

  return (
    <>
      <Helmet>
        <title>
          {GetString('PAGE_TITLE_DEVICE_TRENDS')} | {APP_TITLE}
        </title>
      </Helmet>
      <Header
        open={true}
        pageDisplayed={GetString('PAGE_TITLE_DEVICE_TRENDS')}
      />
      <Paper className={classes.paperGrid}>
        <TrendsContainer />
      </Paper>
    </>
  );
}
